<!-- 圆形进度条组件 -->
<template>
	<transition name="loader-fade">
		<div v-show="isLoading" class="contentBox" @click.stop="close">
			<div class="mask"></div>
			<div class="contents flexCenterColumn">
				<circleProgress style="width: 130px;height: 130px;" :rateText="nowRate" :nowRate="nowRate" :r="60"></circleProgress>
				<p style="margin-top: 10px;font-size: 20px;">{{title}}</p>
			</div>
		</div>
	</transition>
</template>

<script>
	import circleProgress from '@/components/module/universal/base/circleProgress.vue'
	export default {
		components: {
			circleProgress
		},
		props: [],
		computed: {},
		data() {
			return {
				nowRate: 0,
				isLoading: false,
				title: '',
			}
		},
		created() {},
		watch: {},
		methods: {
			open(title, rate) {
				this.title = title
				this.nowRate = rate
				this.isLoading = true
			},
			close() {
				this.isLoading = false
			}
		}
	}
</script>
<style>
	.mask {
		width: 100%;
		height: 100%;
		position: fixed;
		background: none;
		left: 0;
		top: 0;
		z-index: 99;
	}

	.contents {
		z-index: 999;
		position: fixed;
		right: 0;
		left: 0;
		top: 30%;
		width: 2rem;
		height: 2rem;
		margin: auto;
		padding: 0;
		background: white;
		border-radius: 10px;
		color: black;
		margin-top: .7rem;
		text-align: center;
		padding: 0.1rem;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	.loader-fade-enter-active {
		animation: all 0.3s linear forwards;
	}

	.loader-fade-leave-active {
		transition: all 1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}

	.loader-fade-enter,
	.loader-fade-leave-to {
		opacity: 0;
	}
</style>
